import React, { ReactNode } from 'react';
import { SimpleBlock, Text } from 'ui-builder';

import styles from './ClickableBlock.module.scss';
import { Colors, Spacings } from 'react-native-ui-lib';

export function ClickableBlock(props: {
  title: ReactNode,
  titleLine2?: ReactNode,
  content?: ReactNode,
  buttons?: ReactNode,
  onClick?: () => void,
  small?: boolean,
  active?: boolean
}) {
  return (
    <SimpleBlock
      className={`${styles.block} ${!props.content && styles.noContent} ${props.small ? styles.small : ''} ${props.active ? styles.active : ''}`}
      onClick={props.onClick}
      style={{
        padding: Spacings.s2,
        borderRadius: Spacings.s1,
        flexGrow: 0,
        ...props.active ? {
          backgroundColor: Colors.green5,
        } : {},
      }}
    >
      {props.buttons ? (<SimpleBlock className={styles.buttons}>
        {props.buttons}
      </SimpleBlock>) : null}
      <SimpleBlock className={styles.title}>
        <Text style={{ fontSize: 14 }}>{props.title}</Text>
        {props.titleLine2 && (
          <SimpleBlock>
            {props.titleLine2}
          </SimpleBlock>
        )}
      </SimpleBlock>
      {props.content ? (<SimpleBlock className={styles.content}>
        <Text>{props.content}</Text>
      </SimpleBlock>) : null}
    </SimpleBlock>
  );
}
